import {StyledCommentsHistory} from './comments.styled';
import {useTranslation} from 'react-i18next';
import {Tabs, Tab} from 'react-bootstrap';
import CommentsList from './CommentsList';
import {useDispatch} from 'react-redux';
import {useEffect, useState} from 'react';
import {hideLoader, showLoader} from '../../store/common/slice';
import AddComment from './AddComment';
import {GAEvent} from '../../common/google_analytics/google_analytics';
import { constants } from '../../common/constants/constants';
import {useAccessToken} from '../../common/hooks/useAccessToken';
import {isDemoAccount} from '../../common/shared/statelessMethods';
import commentMock from "../../common/mocks/demoAccount/he/managers/apartmentComments.json";

export default function CommentsHistory({buildingId, currentApartment, hideTitle}) {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const client = useAccessToken();
    const [managerComments, setManagerComments] = useState([]);
    const [bllinkComments, setBllinkComments] = useState([]);


    useEffect(() => client != null && loadComments(), [buildingId, currentApartment, client]);

    const loadComments = async () => {
        let comments;
        // requested by shaked to show fake comments for the demo sales building
        if (isDemoApartment(buildingId, currentApartment.apartmentNumber)){
            comments = commentMock.comments;
        }else {
            const response = await client.managers.buildings.getComments(buildingId, currentApartment.apartmentNumber) ?? {comments: []};
            comments = response.comments;
        }
        setManagerComments(comments?.filter(item => !item.createdBy.includes('@bllink.co')) || []);
        setBllinkComments(comments?.filter(item => item.createdBy.includes('@bllink.co')));
    }


        const isDemoApartment = (buildingId, apartmentNumber) => {
            return isDemoAccount(buildingId) && ['1','2'].includes(apartmentNumber)
        }


        const createComment = async text => {
        dispatch(showLoader());

        const response = await client.put(`/managers/comments`, {
            entityType: 'apartment',
            entityId: currentApartment.value,
            text: text
        });

        if (response.id) GAEvent(constants.GoogleAnalytics.Events.comments, 'commentAddedEvent', text, 'commentAddedSuccess');

        await loadComments();
        dispatch(hideLoader());
    }

    return (
        <StyledCommentsHistory>
            {!hideTitle && <h3>{t('comments.history')}</h3>}
            <div className="comments-tabs">
                <Tabs defaultActiveKey="manager">
                    <Tab eventKey="manager" title={t('comments.manager')}>
                        <CommentsList
                            commentsList={managerComments}
                        />
                        <AddComment
                            withBorder={managerComments.length > 0}
                            onEnter={createComment}
                        />
                    </Tab>
                    <Tab eventKey="bllink" title={t('comments.bllink')}>
                        <CommentsList
                            commentsList={bllinkComments}
                        />
                    </Tab>
                </Tabs>
            </div>
        </StyledCommentsHistory>
    )
}
